import {
  inject,
  Injectable,
  isDevMode,
  LOCALE_ID,
  signal,
} from '@angular/core';
import { UserSettingsLanguageService } from 'angular-services/user-area/user-settings-language.service';

@Injectable({ providedIn: 'root' })
export class I18nService {

  private readonly localId = inject(LOCALE_ID);
  private readonly userSettingsLanguageService = inject(UserSettingsLanguageService);

  public readonly currentLanguage = signal<string>(this.localId.replace(/-[A-Z]+$/, ''));

  public async setLanguage(language: string) {
    await this.userSettingsLanguageService.setLanguage(language);
    if (!isDevMode()) {
      this.redirect(language);
    }
    this.currentLanguage.set(language);
  }

  public redirect(next: string, current: string = this.currentLanguage()) {
    if (current === next) {
      console.warn('[I18nService] redirect not required - language unchanged');
      return;
    }
    const redirectUrl =
      location.origin +
      location.pathname.replace(new RegExp(`^/${ current }`), `/${ next }`) +
      location.search;
    console.log('[I18nService] redirect to: ' + redirectUrl);
    location.replace(redirectUrl);
  }

}
